const c = {
  name: "Whale",
  dimensions: { width: 40, height: 33 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 33" style="enable-background:new 0 0 40 33;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,14.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C33.8,13.7,34.3,14.2,35,14.2z"
			/>
		<path class="st0" d="M3,0c3.9,0,7,3.1,7,7v1h30v8c0,8.8-7.2,16-16,16c-2.7,0-5.2-0.7-7.4-1.8C15.3,31.9,13.3,33,11,33H8v-3
			c0-2.2,1-4.1,2.5-5.4C8.9,22.1,8,19.2,8,16v-0.1C6.7,17.2,5,18,3,18H0v-3c0-2.5,1.4-4.8,3.4-6C1.4,7.8,0,5.5,0,3V0H3z M8,8V7
			c0-2.8-2.2-5-5-5H2v1c0,2.8,2.2,5,5,5H8z M21.8,29.8c0.7,0.1,1.5,0.2,2.2,0.2c7.4,0,13.4-5.7,14-13C30.3,17.5,23.9,22.7,21.8,29.8
			z M19.8,29.4c2.3-8,9.5-13.9,18.2-14.3v-5H10v6c0,2.8,0.8,5.4,2.2,7.6C13.1,23.2,14,23,15,23h3v3c0,0.9-0.2,1.7-0.4,2.4
			C18.3,28.8,19,29.1,19.8,29.4z M8,11v-1H7c-2.8,0-5,2.2-5,5v1h1C5.8,16,8,13.8,8,11z M16,25h-1c-2.8,0-5,2.2-5,5v1h1
			c2.8,0,5-2.2,5-5V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Whale
};
